import React, { Component } from 'react';
import { Input } from 'antd';

class Redirect extends Component {
  changeValue = (value) => {
    const form = Object.assign({}, this.props.value.data);
    form['redirect_url'] = value !== undefined ? value : null;
    this.props.changeValue(this.props.value.type, form);
  }

  render() {
    return (
      <div className="four-options">
        <h4>Redirect Url</h4>
        <div className="option-inputs" style={{ width: '100%', padding: '0 5px' }}>
          <Input value={this.props.value.data.redirect_url} onChange={(e) => this.changeValue(e.target.value)} />
        </div>
      </div>
    );
  }
}

export default Redirect;